import React from 'react';
import { useProjectStore } from '../../stores/projectStore';
import { useNotificationStore } from '../../stores/notificationStore';
import { Dialog } from '../common/Dialog';
import { Button } from '../common/Button';
import { WorkspaceId } from '../../../types';
import * as styles from './DeleteWorkspaceDialog.css.ts';

interface DeleteWorkspaceDialogProps {
  isOpen: boolean;
  workspaceId: WorkspaceId;
  workspaceName: string;
  onClose: () => void;
}

export const DeleteWorkspaceDialog: React.FC<DeleteWorkspaceDialogProps> = ({
  isOpen,
  workspaceId,
  workspaceName,
  onClose,
}) => {
  const project = useProjectStore((state) => state.project);
  const deleteWorkspace = useProjectStore((state) => state.deleteWorkspace);
  const workspaces = project?.workspaces ?? [];
  const { error: showError } = useNotificationStore();

  const handleDelete = () => {
    // ワークスペースが1つしかない場合は削除させない
    if (workspaces.length <= 1) {
      showError('Cannot delete the last workspace');
      return;
    }

    deleteWorkspace(workspaceId);
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Workspace"
      width="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </>
      }
    >
      <div>
        <p className={styles.message}>
          Are you sure you want to delete the workspace "{workspaceName}"?
        </p>
        <p className={styles.warning}>
          This action cannot be undone. All tabs in this workspace will be closed.
        </p>
      </div>
    </Dialog>
  );
};